import React from 'react';
import { CtaButton } from './CtaButton';
import { CheckCircle2 } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-black py-20 px-6 flex flex-col items-center text-center w-full relative overflow-hidden" data-id="element-237">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#D98BAF]/10 via-black to-black pointer-events-none" data-id="element-238"></div>

      <div className="max-w-7xl mx-auto flex flex-col items-center relative z-10" data-id="element-239">
        <p className="text-[#D98BAF] font-serif text-xl md:text-2xl mb-3 tracking-wide" data-id="element-240">
          ¡Este valor especial estará sólo por tiempo limitado!
        </p>
        <h2 className="text-white font-serif font-bold text-4xl md:text-6xl mb-12 tracking-tight" data-id="element-241">
          ACCEDÉ AHORA
        </h2>

        {/* Offer Card */}
        <div className="w-full max-w-xl bg-white rounded-[2.5rem] overflow-hidden flex flex-col items-center pb-10 shadow-[0_20px_50px_-12px_rgba(217,139,175,0.25)] border border-[#D98BAF]/30 relative" data-id="element-242">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-cream via-[#D98BAF] to-brand-cream" data-id="element-243"></div>

          {/* Main Mockup */}
          <img src="https://cdn.magicpatterns.com/uploads/p3ogb6j1yeC81svYinY9QR/pasted-image.png" alt="Mockup completo del programa" className="w-full h-auto mb-6 md:scale-105 drop-shadow-xl" data-id="element-244" />

          {/* Benefits List */}
          <ul className="text-left px-8 w-full space-y-4 mb-8 md:grid md:grid-cols-1 md:gap-5 max-w-md" data-id="element-245">
            {['Acceso Permanente', 'Soporte + Actualizaciones', '6 BONOS de regalo 🎁', 'Garantía de satisfacción', <>
                <strong className="font-bold" data-id="element-246">
                  CONSULTORÍAS EN VIVO SEMANALES
                </strong>{' '}
                <em className="not-italic opacity-70 text-sm" data-id="element-247">(opcional)</em>
              </>].map((item, i) => <li key={i} className="flex gap-4 font-serif text-brand-navy/90 text-lg items-start" data-id="element-248">
                <CheckCircle2 className="text-[#D98BAF] shrink-0 mt-0.5" size={22} strokeWidth={2.5} data-id="element-249" />
                <span className="leading-snug" data-id="element-250">{item}</span>
              </li>)}
          </ul>

          {/* Pricing */}
          <div className="flex flex-col items-center w-full px-6" data-id="element-251">
            <p className="text-red-500/80 font-serif font-semibold text-xl md:text-2xl line-through mb-1 tracking-wide" data-id="element-252">
              ANTES $149.999 ARS
            </p>
            <p className="text-brand-navy font-serif font-bold text-3xl md:text-4xl mb-2" data-id="element-253">
              ¡SÓLO POR HOY! 😱
            </p>
            <p className="text-emerald-500 font-serif font-black mb-5 text-[48px] md:text-[64px] tracking-tighter drop-shadow-sm" data-id="element-254">
              $49.999 ARS
            </p>

            <div className="bg-emerald-500 text-white py-2.5 px-8 rounded-full flex items-center gap-2 mb-4 md:scale-110 shadow-md" data-id="element-255">
              <span className="font-bold text-sm tracking-wide uppercase" data-id="element-256">
                100% recomendado
              </span>
              <span className="text-yellow-300" data-id="element-257">⭐⭐⭐⭐⭐</span>
            </div>

            <p className="text-brand-navy/70 font-serif font-medium text-lg md:text-xl mb-6" data-id="element-258">
              Hasta 3 cuotas
            </p>
          </div>

          {/* CTA Button */}
          <div className="px-6 w-full mb-4 md:scale-110 md:my-4" data-id="element-259">
            <CtaButton variant="gold" className="shadow-2xl hover:shadow-[0_10px_30px_rgba(217,139,175,0.4)] transition-shadow duration-300" href="https://qpx0er-vn.myshopify.com/cart/47110721011796:1?channel=buy_button" data-id="element-260">
              ¡SI QUIERO ACCEDER AHORA!
            </CtaButton>
          </div>

          {/* Payment Badges */}
          <div className="flex flex-col items-center gap-0 px-6 w-full opacity-90" data-id="element-261">
            
            <img src="https://cdn.magicpatterns.com/uploads/dLNqUGgPbTw3PFKmET984a/pasted-image.jpg" alt="Métodos de pago — Site seguro SSL certificado, compra 100% segura" className="w-full h-auto max-w-full block rounded-2xl mt-2" data-id="element-262" />
          </div>
        </div>

        {/* Guarantee Section */}
        <div className="mt-20 flex flex-col items-center max-w-md w-full mb-16" data-id="element-263">
          <div className="w-full bg-[#151522] rounded-[2rem] p-8 md:p-10 flex flex-col items-center shadow-[0_20px_50px_-12px_rgba(217,139,175,0.15)] border border-white/5 relative overflow-hidden" data-id="element-264">
            {/* Top Glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-[#D98BAF]/20 blur-[50px] pointer-events-none" data-id="element-265"></div>

            {/* Shield Icon */}
            <div className="w-20 h-20 bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark rounded-2xl flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(217,139,175,0.4)] relative z-10" data-id="element-266">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-267">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-268" />
              </svg>
            </div>

            <h3 className="text-[#D4AF37] font-sans font-black text-2xl md:text-3xl text-center mb-8 uppercase tracking-tight leading-tight" data-id="element-269">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>

            {/* Inner Box */}
            <div className="w-full border border-white/10 bg-white/[0.02] rounded-2xl p-6 md:p-8 flex flex-col items-center text-center mb-6" data-id="element-270">
              <p className="text-white/90 font-sans text-lg md:text-xl font-medium mb-6" data-id="element-271">
                Accedes al programa. Lo aplicás en tus videos.
              </p>
              <p className="text-white/80 font-sans text-base md:text-lg mb-6" data-id="element-272">
                Si en 7 días no es exactamente lo que esperabas:
              </p>
              <p className="text-[#D98BAF] font-sans font-black text-3xl md:text-4xl mb-6 drop-shadow-[0_0_15px_rgba(217,139,175,0.3)]" data-id="element-273">
                devolución del 100%
              </p>
              <p className="text-white font-sans font-bold text-lg md:text-xl" data-id="element-274">
                sin formularios, sin drama, sin explicaciones.
              </p>
            </div>

            <p className="text-white/50 font-sans text-sm md:text-base" data-id="element-275">
              Tasa de devoluciones:{' '}
              <strong className="text-[#D98BAF] font-bold" data-id="element-276">menos del 1%</strong>
              .
            </p>
          </div>

          <div className="space-y-8 w-full max-w-md" data-id="element-277">
            <h3 className="text-white font-sans font-bold text-3xl md:text-4xl tracking-tight" data-id="element-278">
              ¿Dudas? <br data-id="element-279" />{' '}
              <span className="text-[#D98BAF]" data-id="element-280">¡Comunícate conmigo!</span>
            </h3>

            <a href="https://api.whatsapp.com/send/?phone=5491169196692&text=Hola+Quiero+acceder+a+la+formular+creadora+de+contenido+UGC.+Mi+nombre+es+&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="block w-full max-w-sm mx-auto transition-transform hover:scale-105 active:scale-95" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/jywVCyikDEJMp2T5JmNzTH/pasted-image.png" alt="Whatsapp Soporte" className="w-full h-auto drop-shadow-[0_10px_25px_rgba(37,211,102,0.3)]" data-id="element-282" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}